import * as types from "../../actions/companylevel/index";
export default function(state = [], action) {
  switch (action.type) {
    case types.COMPANY_DEDUCTION_SAVED_PAGES:
      return action.payload;

    default:
      return state;
  }
}
